import { useInstance } from 'react-ioc';
import Api from 'api';

export function useApi(): Api {
    return useInstance(Api);
}